import styled from 'styled-components'
import { InputError as NotinoInputError } from '@notino/react-styleguide'

export const InputError = styled(NotinoInputError)`
	margin: 0;
`
